import React, { useState, useEffect } from 'react';
import Navbar from './AdminNav';
import AdminDashboardBlocks from './components/AdminDashboardBlocks';
import NoticesTable from './components/NoticesTable';
import { Typography } from '@mui/material';
import Footer from '../Footer';
const AdminDashboard = () => {
 
  return (
    <>
    <Navbar />
    <div className="background-prop">
        <div style={{ maxWidth: "1200px", margin: "auto", padding: "20px", backgroundColor:"#fff" }}>
            <Typography variant="h4" sx={{ m: 2 }}>
                Admin Dashboard
            </Typography>
      <AdminDashboardBlocks />
      </div>
       <div style={{ maxWidth: "1200px", margin: "auto", padding: "20px", backgroundColor:"#fff" }}>
      <NoticesTable />
      </div>
      </div>
      <Footer />
    </>
  );
};

export default AdminDashboard;
